import * as UpgradeFlightClass from './components/UpgradeFlightClass/UpgradeFlightClass.css';
import * as FlightSelector from './components/FlightSelector/FlightSelector.css';
import * as SelectableSegment from './components/SelectableSegment/SelectableSegment.css';

export default {
	UpgradeFlightClass,
	FlightSelector,
	SelectableSegment
};
